import { useSelector } from 'react-redux'
import { IAlphaprocessState } from '../store'

// Development builds only: localStorage "alphaprocess.boardsV2" = "1" forces the v2 board on
export function forcedBoardsV2(): boolean {
  if (process.env.NODE_ENV !== 'development') return false
  try {
    return localStorage.getItem('alphaprocess.boardsV2') === '1'
  } catch {
    return false
  }
}

// Kanban v2 (beta): the user's own choice, else the company setting (backend User#boards_v2_enabled?)
export default function useBoardsV2(): boolean {
  const enabled = useSelector((state: IAlphaprocessState) => !!state.core.user?.boards_v2_enabled)
  return enabled || forcedBoardsV2()
}
